import { render } from "./step3.vue?vue&type=template&id=051c62a5"
import script from "./step3.vue?vue&type=script&lang=js"
export * from "./step3.vue?vue&type=script&lang=js"

import "./step3.vue?vue&type=style&index=0&id=051c62a5&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__